import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';
import Portal from 'utils/portal/Portal';

import QuestionnaireListBrowser from './QuestionnaireListBrowser';
import HeaderPortal from '../../../../components/layout/HeaderPortal';
import HeaderLinks from './header/HeaderLinks';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_QUESTIONNAIRES } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/questionnaires/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_QUESTIONNAIRES} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_QUESTIONNAIRES}>
        <QuestionnaireListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
